/**
 * Sections that carry NO completion criterion — s177 (A2), D-177.9b.
 *
 * A section listed here returns `null` from `computeSectionProgress`: no green check, no
 * "needs attention", no contribution to any denominator. It renders and accepts data exactly
 * as before; it simply is not SCORED.
 *
 * ⏳ TIME-BOXED TO PLANNER-MAGIC-1. This set exists for exactly one reason and should empty
 * itself when the onboarding interview ships.
 *
 * WHY the five password-log sections are here. s177 retired the product's suggestion rows
 * because completion was measuring the product's guesses rather than the planner's estate
 * (D-176.21 / D-177.4). The password-log sections were the ONE exception (D-177.9a): a list of
 * "Facebook / Instagram / Dropbox / CRA My Account…" is genuinely useful, because you do not
 * remember your online accounts — you recognise them. Reade ruled the checklists stay.
 *
 * But keeping them scored would keep the exact dishonesty the charter set out to end: a planner
 * held short of complete by rows representing accounts they may not have. Hence the split —
 * keep the RECOGNITION value, drop the OBLIGATION. In the interim they are a prompt, not a test.
 *
 * WHEN THIS GOES AWAY. The interview replaces these checklists with checkbox questions ("which
 * of these do you use?") that create only the rows the planner actually has. Those rows are REAL
 * records, so scoring them is honest and resumes with no change beyond deleting the entry here.
 *
 * 🔴 Deliberately its own module rather than a literal inside `section-progress.ts`: that file is
 * a CI-protected path, and a set the tests must read is data, not logic.
 */
import { SECTION_SLUGS } from "./sections";

export const SCORING_EXEMPT_SECTIONS: ReadonlySet<string> = new Set<string>([
  SECTION_SLUGS.PASSWORD_LOG_DEVICES_LOCAL_ACCESS,
  SECTION_SLUGS.PASSWORD_LOG_PRIMARY_EMAIL_IDENTITY_ACCOUNTS,
  SECTION_SLUGS.PASSWORD_LOG_GOVERNMENT_TAX,
  SECTION_SLUGS.PASSWORD_LOG_ONLINE_ACCOUNTS_COMMUNITIES,
  SECTION_SLUGS.PASSWORD_LOG_DIGITAL_FILES_CLOUD_STORAGE,
]);
